/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Common_GuestInputs */

const en_auth_common_guest = /** @type {(inputs: Auth_Common_GuestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guest`)
};

const es_auth_common_guest = /** @type {(inputs: Auth_Common_GuestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitado`)
};

/**
* | output |
* | --- |
* | "Guest" |
*
* @param {Auth_Common_GuestInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_common_guest = /** @type {((inputs?: Auth_Common_GuestInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Common_GuestInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_common_guest(inputs)
	return es_auth_common_guest(inputs)
});